module.exports = __webpack_public_path__ + "assets/sign.e19e4234.svg";